<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible.sync="visible"
    width="610px"
    :title="
      $l('INDEX.dialog_title_batch_price_update') || '批量更新默认工厂价格'
    "
    :close-on-click-modal="false"
    :before-close="() => close()"
    destroy-on-close
    append-to-body
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="mini"
      :validate-on-rule-change="false"
    >
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_default_factory') || '默认工厂'"
          >
            <el-input v-model="formData.defaultFactoryScmName" disabled="true" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.form_label_ftyPrice') || '工厂单价(rmb)'"
            prop="ftyPrice"
          >
            <el-input-number
              v-model="formData.ftyPrice"
              controls-position="right"
              :step="1"
              :min="0"
              :max="999999999999999"
              :precision="2"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">{{
        $l("INDEX.btn_cancel") || "取 消"
      }}</el-button>
      <el-button size="small" type="primary" @click="save">{{
        $l("INDEX.btn_update") || "更新"
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import validate from "@/libs/util.validate";
import EditLoading from "@/mixins/edit-loading";
export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: true },
    defaultFactoryScmName: { type: String, default: "" },
    defaultFactoryScmCode: { type: String, default: "" },
  },
  data() {
    return {
      formData: {},
    };
  },
  created() {
    // 初始化 formData
    this.init();
  },
  computed: {
    rules() {
      return {
        deafultScmName: [
          {
            required: true,
            message: this.$l("INDEX.form_placeholder_scm") || "请选择工厂",
            trigger: " blur",
          },
        ],
        ftyPrice: [
          {
            required: true,
            message:
              this.$l("INDEX.form_placeholder_ftyPrice") || "请输入工厂单价",
            trigger: " blur",
          },
        ],
      };
    },
  },
  methods: {
    init() {
      this.formData = {
        defaultFactoryScmName: this.defaultFactoryScmName,
        defaultFactoryScmCode: this.defaultFactoryScmCode,
      };
    },
    close() {
      this.$emit("close");
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) return;
      const confirm = await this.$confirm(
        this.$l("INDEX.tips_default_confim") || `确定批量修改默认工厂【${this.defaultFactoryScmName}】的价格为【${this.formData.ftyPrice}】吗？`,
        this.$l("INDEX.label_completeDesc") || "确认信息",
        {
          confirmButtonText:
            this.$l("INDEX.product_dialog_btn_confirm") || "确定",
          cancelButtonText: this.$l("INDEX.btn_cancel") || "取消",
          type: "warning",
        }
      )
        .then(() => true)
        .catch(() => false);

      if (!confirm) return;
      const params = {
        ...this.formData,
      };
      this.$emit("saveDefaultFactoryPrice", params);
    },
  },
};
</script>
